export default {"src":"/_next/static/media/payment.0ea81851.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};